import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useMapStore } from '@/store/useMapStore';
import { fetchProductVariants } from '@/services/storefrontService';

export const useProductVariants = (productHandle?: string) => {
  const { setVariants, setLoading, setError } = useMapStore();

  const { data: variants, isLoading, error } = useQuery({
    queryKey: ['product-variants', productHandle],
    queryFn: () => fetchProductVariants(productHandle),
    staleTime: 10 * 60 * 1000, // 10 minutes
  });

  useEffect(() => {
    setLoading(isLoading);
  }, [isLoading, setLoading]);

  useEffect(() => {
    if (error) {
      setError(error instanceof Error ? error.message : 'Failed to load product variants');
    } else {
      setError(null);
    }
  }, [error, setError]);

  useEffect(() => {
    if (variants) {
      setVariants(variants);
    }
  }, [variants, setVariants]);

  return {
    variants,
    isLoading,
    error,
  };
};